import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const FlashText = () => {
  const [flash_Text, setFlash_Text] = useState('');
  const [imageData , setImageData]= useState('');
  const [contentType , setContentType]= useState('');
  const [position , setPosition]= useState('toFlash');
  const [isActive , setIsActive]= useState(true);
  


  const FlashTextUpload = async (e) => {
    e.preventDefault();
    axios.post("https://api.bakpoket.com/api/AdminContent/add-or-update-FlashText",{imageData,flash_Text,contentType,position,isActive})
    .then(request =>{ console.log(request)
      alert(`Flash Text  uploaded successfully`);
      setFlash_Text("")
  })
    .catch(err=>console.log(err))
   
  };

  return (
    <Card>
      <h2 className='text-center text-md-start pt-2 pt-md-0'>Upload Flash Text </h2>
      <form onSubmit={FlashTextUpload}>
        <input
          type="text"
          placeholder="Enter Flash Text"
          value={flash_Text}
          onChange={(e) => setFlash_Text(e.target.value)}
        />
        <button type="submit">Submit</button>
      </form>
    </Card>
  );
};

export default FlashText;


// const Card = styled.div`
//   background-color: white;
//   padding: 30px;
//   border-radius: 12px;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
//   max-width: 400px;
//   width: 100%;

//   h2 {
//     font-size: 22px;
//     margin-bottom: 20px;
//     color: #2a4157;
//   }

//   form {
//     display: flex;
//     flex-direction: column;
//     gap: 15px;

//     input[type="file"] {
//       padding: 10px;
//       border: 1px solid #ccc;
//       border-radius: 6px;
//     }

//     button {
//       padding: 10px 15px;
//       background-color: #ef4766;
//       border: none;
//       color: white;
//       border-radius: 6px;
//       cursor: pointer;
//       font-weight: 600;
//       transition: background 0.3s;

//       &:hover {
//         background-color: #d63c5b;
//       }
//     }
//   }

//   @media (max-width: 768px) {
//     max-width: 220px;
//     width: 85%;
//     padding: 5px;

//     h2 {
//       font-size: 13px;
//     }

//     button {
//       font-size: 10px;
//       padding: 8px 12px;
//     }

//     input[type="file"] {
//       padding: 6px;
//       border: 1px solid #ccc;
//       border-radius: 6px;
//       font-size:11px;
//     }
//   }
// `;



const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  height:auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    input[type="file"],input[type="text"],input[type="number"],select  {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 5px;

    h2 {
      font-size: 13px;
      
    }

    button {
      font-size: 10px;
      padding: 8px 12px;
    }

    input[type="file"],input[type="text"],input[type="number"],select {
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size:11px;
    }
  }

  @media (max-width: 576px) {
    h2 {
      margin-bottom:5px;
    }

    form {
        gap: 5px;
    }

    hr{
      margin:5px;
    }
  }
`;


const TableWrapper = styled.div`
  margin-top: 20px;
  overflow-x: auto;

  h3 {
    color: #2a4157;
    font-size: 18px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 10px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 13px;
      margin-bottom: 7px;
    }

    table {
    width: 100%;
    font-size: 7px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 2px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }
  }
`;